"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePortalMountNodeStylesStyles", {
    enumerable: true,
    get: function() {
        return usePortalMountNodeStylesStyles;
    }
});
const _react = require("@griffel/react");
const usePortalMountNodeStylesStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        qhf8xq: "f1euv43f",
        Bhzewxz: "f15twtuk",
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        Bj3rh1h: "f494woh"
    }
}, {
    d: [
        ".f1euv43f{position:absolute;}",
        ".f15twtuk{top:0;}",
        ".f1vgc2s3{left:0;}",
        ".f1e31b4d{right:0;}",
        ".f494woh{z-index:1000000;}"
    ]
}); //# sourceMappingURL=usePortalMountNodeStyles.styles.js.map
